import $ from 'jquery'
import {Core} from "../../../assets/src/scripts/core.js";

export class BigSubmenu {

  constructor() {
    this.$container = $('.big-submenu')

    if (this.$container === undefined) {
      return
    }

    this.classes = {
      'linkLeftClass': '',
      'linkRightClass': '',
      'linkKeepClass': 'btn-small',
      'title': 'big-submenu-title',
      'submenuItemsOpen': 'open',
      'mobileOpenNav': 'open-nav',
    }

    this.$window = $(window)
    this.$body = $('body')
    this.$linkLeft = this.$container.find('.big-submenu-link.link-1 a')
    this.$linkRight = this.$container.find('.big-submenu-link.link-2 a')

    // Classes de base de chaque lien, togglées selon le breakpoint / l'état sticky.
    // La classe btn-small est exclue du toggle pour rester toujours présente.
    this.classes.linkLeftClass = this.getToggleClasses(this.$linkLeft)
    this.classes.linkRightClass = this.getToggleClasses(this.$linkRight)

    this.$title = this.$container.find(`.${this.classes.title}`)
    this.$submenuItems = this.$container.find('ul li.menu-item-has-children')
    this.$overlay = this.$container.find('.big-submenu-overlay')
    this.$childrenTitle = this.$container.find('.children-title')

    this.currentScroll = 0

    this.$window.on('load', this.handleScroll.bind(this))
    this.$window.on('resize', this.handleScroll.bind(this))
    this.$window.on('scroll', this.handleScroll.bind(this))
    this.$window.on('click', this.handleClickWindow.bind(this))

    this.$submenuItems.on('click', '> a', this.handleClickSubmenuItems.bind(this))
    this.$overlay.on('click', this.handleClickOverlay.bind(this))
    this.$childrenTitle.on('click', this.handleClickChildrenTitle.bind(this))

    // Mobile
    this.$title.on('click', this.handleClickTitle.bind(this))
  }

  handleScroll(e) {
    this.$container.removeClass(this.classes.mobileOpenNav)
    this.$submenuItems.removeClass(this.classes.submenuItemsOpen)

    this.toggleLinksButtonClasses()

    this.currentScroll = this.$window.scrollTop()
  }

  handleClickTitle(e) {
    if ( Core.isBpLessThan('lg') ) {
      e.preventDefault()

      const isNavOpen = this.$container.hasClass(this.classes.mobileOpenNav)
      const hasOpenSubmenu = this.$submenuItems.hasClass(this.classes.submenuItemsOpen)

      if (isNavOpen && hasOpenSubmenu) {
        this.$container.removeClass(this.classes.mobileOpenNav)
        this.$submenuItems.removeClass(this.classes.submenuItemsOpen)
        return
      }

      const willOpen = !isNavOpen
      this.$container.toggleClass(this.classes.mobileOpenNav)

      if (willOpen) {
        this.$body.removeClass('header-hidden')
        this.repositionBelowHeader()
      }

      this.toggleLinksButtonClasses()
    }
  }

  handleClickSubmenuItems(e) {
    e.preventDefault()
    let $li = $(e.target).closest('li')

    if ( $li.hasClass(this.classes.submenuItemsOpen) ) {
      $li.removeClass(this.classes.submenuItemsOpen)
      return
    }

    this.$submenuItems.removeClass(this.classes.submenuItemsOpen)
    $li.toggleClass(this.classes.submenuItemsOpen)
  }

  handleClickWindow(e) {
    let $item = $(e.target).closest('.big-submenu')

    if ( $item.length ) {
      return
    }

    this.$container.removeClass(this.classes.mobileOpenNav)
    this.$submenuItems.removeClass(this.classes.submenuItemsOpen)
  }

  handleClickOverlay(e) {
    this.$container.removeClass(this.classes.mobileOpenNav)
    this.$submenuItems.removeClass(this.classes.submenuItemsOpen)
  }

  handleClickChildrenTitle(e) {
    $(e.currentTarget)
      .closest('li.menu-item-has-children')
      .removeClass(this.classes.submenuItemsOpen)
  }

  repositionBelowHeader() {
    const $content = this.$container.find('.big-submenu-content')

    if (!$content.hasClass('js-sticky-middle')) {
      return
    }

    const $header = $('header.header')

    if (!$header.length) {
      return
    }

    const headerTop = parseInt($header.css('top'), 10) || 0
    $content.css('top', headerTop + $header.outerHeight(true) - 2)
  }

  getToggleClasses($link) {
    return ($link.attr('class') || '')
      .split(/\s+/)
      .filter((cls) => cls && cls !== this.classes.linkKeepClass)
      .join(' ')
  }

  toggleLinksButtonClasses() {
    const shouldUseButtonClasses = Core.isBpLessThan('lg') || this.$body.hasClass('header-hidden')

    if (this.classes.linkLeftClass) {
      this.$linkLeft.toggleClass(this.classes.linkLeftClass, shouldUseButtonClasses)
    }

    if (this.classes.linkRightClass) {
      this.$linkRight.toggleClass(this.classes.linkRightClass, shouldUseButtonClasses)
    }
  }
}
